import { timestampToDate } from '@utils';

export const extractPatientInformation = (data: string) => {
  const splitData = data.split(';');

  const profilePicture =
    !splitData[18] || splitData[18] === 'null' || splitData[18] === 'undefined'
      ? null
      : splitData[18];
  return {
    firstname: splitData[0],
    lastname: splitData[1],
    birthdate: timestampToDate(+splitData[2]),
    apiKey: splitData[3],
    authDomain: splitData[4],
    databaseURL: splitData[5],
    storageBucket: splitData[6],
    patientSourceUUID: splitData[7],
    userSiteName: splitData[8],
    userSiteId: parseInt(splitData[10], 10),
    userSiteLogo: splitData[11],
    assetApiKey: splitData[12],
    projectId: splitData[14],
    patientUUID: splitData[17],
    profilePicture,
  };
};
